import { gql } from "@/services/httpAdapter";

export const onUpdateCustomerEngagementTrail = gql`
	subscription onUpdateCustomerEngagementTrail($locationId: String, $commissionCycleId: String) {
		onUpdateCustomerEngagementTrail(locationId: $locationId, commissionCycleId: $commissionCycleId) {
			_id
			locationId
			commissionCycleId

			engagementInfo {
				_id
				activityId
				activity
				action
				activityType
				activityTimeStamp
				salesEmployeeId
				contactId
				customerId
			}
		}
	}
`;
